define("settings/components/social-identity/sort-profiles", ["exports", "@ember/component", "@ember/object/computed", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _computed, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object/computed",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{yield (hash orderedProfiles=this.orderedProfiles)}}
  */
  {
    "id": "PEtcguw7",
    "block": "[[[18,1,[[28,[37,1],null,[[\"orderedProfiles\"],[[30,0,[\"orderedProfiles\"]]]]]]]],[\"&default\"],false,[\"yield\",\"hash\"]]",
    "moduleName": "settings/components/social-identity/sort-profiles.hbs",
    "isStrictMode": false
  });

  /**
   * @module Components
   */
  let SortProfilesComponent = _exports.default = (_dec = (0, _computed.sort)('args.profiles', function (a, b) {
    if (this.defaultSorting.indexOf(a.profileType) > this.defaultSorting.indexOf(b.profileType)) {
      return 1;
    } else if (this.defaultSorting.indexOf(a.profileType) < this.defaultSorting.indexOf(b.profileType)) {
      return -1;
    }
  }), (_class = class SortProfilesComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "defaultSorting", ['instagram', 'facebook', 'twitter', 'pinterest', 'tiktok']);
      _initializerDefineProperty(this, "orderedProfiles", _descriptor, this);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "orderedProfiles", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SortProfilesComponent);
});